<template>
  <div id="result" class="div_card">
    <div v-if="inputData==null">      
      <el-alert
        title="資料讀取中…"
        type="info"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div>
    <div v-else-if="inputData!=null && inputData.status==1">
      <div class="">
        <div class="">
          <table class="w-100" style="background-color: azure; border: gray;" rules="all" bgcolor="#FFFFFF" >
            <thead>
              <tr>
                <th colspan="4" class="ncut-base-form-title" style="background-color: orange; text-align:left; padding: 0.5em;">錄取結果如下:</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td class="ncut-base-form-title" style="width: 14%;padding:0.5em;">考生姓名</td>
                <td colspan="2" style="padding:0.1em;">
                  <span class="badge badge-info" style="font-size:1.25rem">{{inputData.name}}</span>
                </td>
                <td class="ncut-base-form-title" style="width: 14%;padding:0.5em;">申請編號</td>
                <td colspan="2" style="padding:0.1em;">
                  <span class="badge badge-info" style="font-size:1.25rem">{{inputData.regNo}}</span>
                </td>
              </tr>
              <tr>
                <td class="ncut-base-form-title" style="padding:0.5em;">錄取狀況</td>
                <td colspan="5" style="padding:0.1em;">
                  <span class="badge" style="font-size: 1.5rem"
                        v-bind:style="{'background': statusColor}">{{inputData.note}}</span>
                </td>
              </tr>
              <tr>
                <td class="ncut-base-form-title" style="padding:0.5em;">錄取系科</td>
                <td colspan="5" style="padding:0.1em;">
                  <span class="badge badge-primary" style="font-size:1.5rem">{{inputData.deptName}}</span>
                </td>
              </tr>
              <tr>
                      <td class="ncut-base-form-title ncut-require-title">報到文件</td>
                      <td class="ncut-ipnut-form-ipt" colspan="2" style="vertical-align: top;">
                        <ul style="clear:both" v-if="(inputData.info2 != null) && (inputData.info2.length > 0)" class="response">
                          <li class="sel-file" v-for="(f,index) in filterImg2List" :key="index" :index="'0'+index" :name="'ID'+index">
                            <a :href="'./WebApi/Tools/GetDocument/'+f.rowId" target="_blank">
                              <img v-if="f.img != null" :src="f.img" style="width: 2em;" />
                              <img v-if="f.img == null" src="@/assets/images/disk.png" /> {{f.name}}{{f.ext}}
                            </a>
                            &nbsp;&nbsp;<i class="el-icon-delete"
                                          @click="setDelFlag(f)"></i>
                          </li>
                        </ul>
                        <el-upload
                          ref="upload"
                          action="./WebApi/Tools/UploadV2"
                          accept=".jpg,.pdf"
                          :name="'f' + inputData.documentID + '_8' + (info2==null?0:info2.length)"
                          :on-success="handleAvatarSuccess"
                          :on-remove="handleChangeF2"
                          :before-upload="onBeforeUploadF2">
                          <el-button size="small" type="primary">{{$t('message.Upload_txt')}}<i class="el-icon-upload el-icon--right"></i></el-button>
                        </el-upload>
                      </td>
                      <td class="ncut-ipnut-form-ipt" colspan="3" style="background:#f0f5e5;">
                        <div style="display: block; font-size:0.9rem;">                        
                          上傳之格式：
                          <ul style="list-style-type:disc; margin-bottom: 0;">
                            <li><b style="color: #CC3300;">可以選擇一或多個檔案。</b></li>                           
                            <li>副檔名 .pdf, .jpg。</li>
                            <li>檔案大小不得超過10MB。</li>
                          </ul>
                        </div>
                      </td>
                    </tr>
              <!-- <tr v-if="1<inputData.showStatus">
                <td class="ncut-base-form-title" style="font-weight:bold; padding: 0.5em;">錄取通知單</td>
                <td colspan="3" style="padding:0.1em;">                  
                  <a :href="'./WebApi/Apply/GetRegisterPrnV2/'+user.dId" download="錄取通知單.pdf">列印</a>
                </td>
              </tr>
              <tr>
                <td class="ncut-base-form-title" style="padding:0.5em;">最低錄取分數</td>
                <td colspan="3" style="padding:0.5em;">
                  <div style="padding: 0.25em 0;">
                    <span>正取生：<span v-if="0<inputData.floor1">{{inputData.floor1| numFilter}}</span><span v-if="0==inputData.floor1">-</span></span>分
                  </div>
                  <div style="padding: 0.25em 0;">
                    <span>備取生：<span v-if="0<inputData.floor2">{{inputData.floor2| numFilter}}</span><span v-if="0==inputData.floor2">-</span></span>分
                  </div>
                </td>
              </tr> -->
              <tr>
                <td class="ncut-base-form-title">備註</td>
                <td colspan="3" style="padding: 0.5em;">
                  <div style="padding: 0.5em 0 0;" 
                    v-html="inputData.entName"/>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div v-else-if="inputData!=null && inputData.status==5">
      <el-alert
        title="您尚無報到資格!"
        type="error"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div>
    <div v-else>
      <el-alert
        title="尚無資料，請耐心等候，謝謝!!"
        type="warning"
        show-icon
        center
        :closable="false">
      </el-alert>
    </div> 
  </div> 
</template>


<script>
export default {
  name: 'firstCheckIn',
  data () {
    return {
      inputData: null,
      info2: null,
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    setting () {
      return this.$store.getters.getSetting
    },
    enroll () {
      return this.$store.getters.getEnrollInfo
    },
    user () {
      return this.$store.getters.getUser
    },
    filterImg2List: function () {
      if (null != this.inputData.info2) {
        var shoppingList = this.inputData.info2;
          return shoppingList.filter(function (item) {
            return item.status!='R'
        });
      }
      return [];
    },
    statusColor () {
      let url = '#d9534f';

      if (null != this.inputData) {        
        switch(this.inputData.showStatus) {
          case 1:
            url = '#fed71a';
            break;
          case 2:
          case 3:
            url = '#5cb85c';
            break;
        }  
      }
      return url
    }
  },
  filters: {
    numFilter(value) {
      let realVal = parseFloat(value).toFixed(2)
      return parseFloat(realVal)
    }
  },
  methods: {
    isNull(data) {
      return ((data != null) && (data != undefined) && (data != "null") ? false : true);
    },
    showErrorMsg(vm, msg) {
      vm.$notify.error({
                        title: vm.$t('message.Error_txt'),
                        dangerouslyUseHTMLString: true,
                        message: msg,
                        offset: 150
                      });
    },
    printData(data) {
      let url = './WebApi/Apply/GetRegisterPrnV2/'.concat(this.user.dId);
      let params = new URLSearchParams();
      params.append('cdn', this.cdnSelect);

      this.$http.get(url, {    
                  responseType: 'blob',
                  params: params
                }).then((response) => {
                  const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('target','_blank');
                  document.body.appendChild(link);
                  link.click();
                });
    },
    setPhoto() {
      if (null != this.info2) {
        var len = this.info2.length;
        for (var it = 0; it < len; it++) {
          if ('' != this.info2[it].status) {
            if (null == this.inputData.info2) {
              this.inputData.info2 = [this.info2[it]];
            } else {
              this.inputData.info2.push(this.info2[it]);
            }
          }
        }
      }   
      if (null != this.inputData.info2) {
        this.clearImage(this.inputData.info2);
      }   
    },
    clearImage(infoLst) {
      if (null != infoLst) {
        var len1 = infoLst.length;
        for (var it = 0; it < len1; it++) {
          if (infoLst[it].status == 'A') {
            infoLst[it].rowId = '';
          }
          
          infoLst[it].dataUrl = '';
          infoLst[it].img = '';
        }
      }
    },
    checkFileInfo(tInfo, inpInfo) {
      var len = tInfo.length;
      for (var it = 0; it < len; it++) {
        if (tInfo[it].status == 'A' || tInfo[it].rowId.length > 0) {
          inpInfo.push(tInfo[it]);
        }
      }
    },
    handleChangeF2(file, fileList) {
      this.fileList = fileList.slice(-3);
      if (null != this.info2) {          
        var len = this.info2.length;
        var idx = 0;
        for (var i = 0; i < len; i++) {
          if (this.info2[i].tempName == file.name) {
            idx = i;
            break;
          }
        }
        if (-1 < idx) {
          this.info2.splice(idx,1);
        }
      }
    },
    onBeforeUploadF2(file)
    {
      this.fileIndex = 8;
      return this.onBeforeUpload10M(file);      
    },
    onBeforeUpload10M(file)
    {
      this.fileData = file;
      //this.fileFormDataName = this.changeFileName(file.name, "f" + this.inputData.documentID + "_" + this.fileIndex);
      //var imgLst = (1 == this.fileIndex ? ['image/jpeg'] : ['image/jpeg', 'application/pdf']);
      var imgLst = ['application/pdf'];
      var isIMAGE = true;
      
      const isLt10M = file.size / 1024 / 1024 < 10;
      if ((0 < imgLst.length) && (0 > imgLst.indexOf(file.type))) {
        var msg = "檔案格式不支援 (檔案限制為 ";
        for (var i = 0; i < imgLst.length; i++) {
          msg += ".".concat(imgLst[i]);
        }
        msg += ")!";
        isIMAGE = false;
        //this.$message.error(msg);
        this.$notify.error({
                              title: this.$t('message.Error_txt'),
                              message: msg,
                              offset: 150
                          });
      }
      if (!isLt10M) {
        //this.$message.error('檔案大小請勿超過 4MB!');
        this.$notify.error({
                            title: this.$t('message.Error_txt'),
                            message: '檔案大小請勿超過 10MB!',
                            offset: 150
                          });
      }
      
      return (isIMAGE && isLt10M);      
    },generateThumb(file) {
      if (file != null) {
        let vm = this;
        var res = file.name.split("\\");
        var retLen = res.length;
        var name = res[retLen - 1]; 
        var fnName = name.split(".");
        this.$http.get("./WebApi/Tools/GetImageV2/f".concat(this.inputData.documentID).concat("_").concat(this.fileIndex))
                  .then((response) => {
                        if (!this.isNull(response.data)) {
                            vm.imageUrl = response.data;
                        }
                  });
      }
    },
    handleAvatarSuccess(res, file) {
      var nmObj = file.response[0].name.trim().split('\\');
      var objLen = nmObj.length;
      if (file.response[0].type == 'image/jpeg') {
        file.response[0].ext = '.jpg';
        if (this.fileIndex == 1) {
          this.generateThumb(file.response[0]);
        }
      } else if (file.response[0].type == 'application/pdf') {
        file.response[0].ext = '.pdf';
      }
      switch(this.fileIndex) {        
        case 8: // 影本
                if (this.info2 != null) {
                  this.info2.push(file.response[0]);
                } else {
                  this.info2 = [file.response[0]];
                }
                break;    
        default:                
                break;
      }
    },
    removeAllTempFiles(files, index, type) {
      if ((null != files) && (null != files[index])) {
        let vm = this
        var flag = false;
        for (var i = 0; i < files[index].length; i++, !flag) {
          if ('A' == files[index][i].status) {
            files[index][i].dataUrl = '';
            vm.$http.put('./WebApi/Tools/RemoveFiles',files[index])
                    .then((response) =>{
                      flag = true;
                      if (2 == type) {
                        for (var j = 0; j < files[index].length; j++) {
                          if ('A' == files[index][j].status) {
                            files[index][j].status = '';
                          }
                        }
                      }
                    })
                    .catch(function (error) {
                      //vm.$message.error('對不起,網路連線失敗');
                      vm.$notify.error({
                                        title: vm.$t('message.Error_txt'),
                                        dangerouslyUseHTMLString: true,
                                        message: '<strong>對不起,網路連線失敗</strong>',
                                        offset: 150
                                      });
                    });
          }
        }
      }
    },
    removeFile4Item(item, index) {
      if (null != item.info) {
        var fLen = item.info.length;
        for (var i = 0; i < fLen; i++) {
          item.info[i].status = 'R';
        }
      }

      this.removeAllTempFiles(this.info4, index, 2);
    },
    delTempFiles(files,tmpFiles, position) {
      if (null != files && null != files[position]) {
        if ('A' == files[position].status) {
          files.splice(position, 1);
          tmpFiles.splice(position, 1);
          this.removeAllTempFiles(position, 1);
        } else {
          if (null != files[position].info) {
            var fLen = files[position].info.length;
            for (var i = 0; i < fLen; i++){
              files[position].info[i].status = 'R';
            }
          }
          files[position].status = 'R';
        }
      }
    },
    resetPhoto() {
      if (null != this.info1) {
        this.info1 = null;
      }
      if (null != this.info2) {
        this.info2 = null;
      } 
      
      this.imageUrl = null;
      const mainImg = this.$refs.upload;
      if (mainImg && mainImg.length) {
        mainImg.forEach(item => {
          item.clearFiles();
        })
      }

      if (null != this.inputData) {
        if (null != this.inputData.info1) {
          var tmpFile = [];
          var len = this.inputData.info1.length;
          for (var it = 0; it < len; it++) {
            if (this.inputData.info1[it].status != 'R') {
              var tObj = this.checkExtName(this.inputData.info1[it]);
              tmpFile.push(tObj);
            }
          }
          this.inputData.info1 = tmpFile;
        }

        if (null != this.inputData.info2) {
          var tmpFile = [];
          var len = this.inputData.info2.length;
          for (var it = 0; it < len; it++) {
            if (this.inputData.info2[it].status != 'R') {
              var tObj = this.checkExtName(this.inputData.info2[it]);
              tmpFile.push(tObj);
            }
          }
          this.inputData.info2 = tmpFile;
        }       
      }
    },
    setDelFlag(item) {
      item.status='R';
    },
    setModifyFlag(item) {
      if (item.status != 'A') {
        item.status = 'M';
      }
    }

  },

  created () { 
    console.log('======created ResultView=====') 
    var vm = this
    this.$http
        .get('./WebApi/Apply/GetFirstResult/'.concat(this.user.dId))
        .then(function(response) {
          if (response.data != null) {            
            vm.inputData = response.data;
          } else {
            vm.showErrorMsg(vm, '<strong>對不起,讀取<i style="background:yellow;">分發結果</i>查詢失敗:'+error+'</strong>');
          }
        })
        .catch(function (error) {
          vm.showErrorMsg(vm, '<strong>對不起,網路連線失敗' + error+'</strong>');
        })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/FirstCheckInView.vue